class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.closeTimeout = null;

    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onPanelClick = this.onPanelClick.bind(this);

    this.elements.button.addEventListener('click', this.onButtonClick);
    this.addEventListener('keyup', this.onContainerKeyUp);

    // Delegated, not bound per-<a>. The panel is empty at construction now — the 190 rows
    // are cloned in by hydrate() on first open — so there is nothing to bind to yet.
    this.elements.panel.addEventListener('click', this.onPanelClick);
  }

  // The country rows ship once for the whole document, as the inert <template> rendered by
  // snippets/country-list.liquid after </main>. Both disclosures (header and megamenu) clone
  // from it independently; cloneNode keeps them separate so each panel owns its own nodes.
  // Rendering the list inline twice cost 21,732 bytes per copy above the hero, which delayed
  // discovery of the LCP image by that much markup.
  hydrate() {
    if (this.hydrated) return;
    this.hydrated = true;

    const source = document.getElementById('CountryListSource');
    if (!source) return;

    this.elements.panel.appendChild(source.content.cloneNode(true));
  }

  connectedCallback() {
    document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
  }

  isOpen() {
    return !this.elements.panel.hasAttribute('hidden');
  }

  showPanel() {
    this.hydrate();
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
    this.elements.panel.classList.remove('closing');
    this.elements.panel.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', 'true');
  }

  hidePanel() {
    if (!this.isOpen()) return;

    if (this.closeTimeout) clearTimeout(this.closeTimeout);

    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.classList.add('closing');

    this.closeTimeout = setTimeout(() => {
      this.elements.panel.setAttribute('hidden', true);
      this.elements.panel.classList.remove('closing');
    }, 300);
  }

  togglePanel() {
    if (this.isOpen()) this.hidePanel();
    else this.showPanel();
  }

  onButtonClick(e) {
    e.preventDefault();
    this.togglePanel();
    this.elements.button.focus();
  }

  onPanelClick(e) {
    const link = e.target.closest('a');
    if (!link) return;
    this.onItemClick(e, link);
  }

  onDocumentPointerDown(e) {
    if (!this.isOpen()) return;
    if (e.target && this.contains(e.target)) return;
    this.hidePanel();
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event, link) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = link.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);